<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <div>
          <IzbirnikStranke v-on:osvezitevIzbranIdStranka="GetStranka" :selectorPermissions="selectorPermission" />
        </div>
      </div>
    </div>
    <div style="clear: both"/>
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine">
        <p class="open-sans-30pt">
          Nastavitve elektronske pošte
        </p>
        <div style="padding-top: 20px; padding-bottom: 15px"
             id="nastavitve-elektronska-posta">
          <div v-if="seznamNosilnihPrikljuckov.length > 1">
            <p>
              Izberite priključek
              <el-select v-model="izbranPrikljucek" value-key="id_prikljucek" class="izbirnik-prikljuckov">
                <el-option v-for="(data) in seznamNosilnihPrikljuckov"
                           :value="data.id_prikljucek"
                           :label="`${data.naslov}`"
                           :key="data.id_prikljucek">
                </el-option>
              </el-select>
            </p>
          </div>
          <el-tabs type="border-card" @tab-click="HandleTabClick" :value="activetab">
            <el-tab-pane label="E-predali" class="velikost-pisave" name="t1" ref="t1" :lazy="true">
              <PregledPostnihPredalov
                @refreshTab="osvezitevStevec++"
                :izbranPrikljucek="izbranPrikljucek"
                :seznamPrikljuckov="seznamPrikljuckov"
                :poslovnaStranka="poslovnaStranka"
                :osvezitevStevec="osvezitevStevec" />
            </el-tab-pane>
            <el-tab-pane label="Dodajanje e-predalov" name="t2" :lazy="true" ref="t2"  v-if="izbranPrikljucek !== null && moznoDodajanje">
              <DodajanjePostnegaPredala
                :izbranPrikljucek="izbranPrikljucek"
                :osvezitevStevec="osvezitevStevec"
                v-on:osvezitevStraniDodajanje="MetodaOsveziKreiranElektronskiPredal" />
            </el-tab-pane>
            <el-tab-pane label="Nastavitve" name="t3">
              <Nastavitve/>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DodajanjePostnegaPredala from './ElektronskaPosta/DodajanjePostnegaPredala.vue'
import PregledPostnihPredalov from './ElektronskaPosta/PregledPostnihPredalov.vue'
import IzbirnikPrikljuckov from '../GlobalneKomponente/IzbirnikPrikljuckov'
import {Select, Option, Tabs, TabPane} from 'element-ui'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import Nastavitve from './ElektronskaPosta/Nastavitve'
import KomponentaBrezEpredalov from './ElektronskaPosta/KomponentaBrezEpredalov'
import {MixinGetUserData} from '../../../../assets/js/globalne_funkcije/PridobitevUporabniskihPodatkovGlobalno/PridobitevUporabniskihPodatkov'
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke.vue'

export default {
  name: 'NastavitveElektronskaPosta',
  mixins: [MixinGetUserData],
  components: {
    IzbirnikStranke,
    KomponentaBrezEpredalov,
    Nastavitve,
    MixinGetUserData,
    IzbirnikPrikljuckov,
    DodajanjePostnegaPredala,
    PregledPostnihPredalov,
    [Select.name]: Select,
    [Option.name]: Option,
    [TabPane.name]: TabPane,
    [Tabs.name]: Tabs
  },
  data () {
    return {
      seznamPrikljuckov: [],
      izbranPrikljucek: null,
      activetab: 't1',
      osvezitevStevec: 0,
      izbranaStranka: '',
      poslovnaStranka: '',
      selectorPermission: ['STRANKE'],
      // selectorPermission: ['EMAIL_KREIRAJ'],
      seznamNosilnihPrikljuckov: [],
      moznoDodajanje: false
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.GetSeznamPrikljuckov()
  },
  methods: {
    GetStranka (podatkiStranke) {
      if (podatkiStranke !== null) {
        this.izbranaStranka = podatkiStranke
        this.GetPrikljuckiDovoljenja()
      }
    },
    GetPrikljuckiDovoljenja () {
      let seznamNosilnihPrikljuckov = []
      let seznamPrikljuckov = []
      let agp = this.getAllGrantedPermissions()
      let seznamIdPrikljuckov = []
      if (typeof agp['PRIKLJUCKI'] === 'object') {
        agp['PRIKLJUCKI'].additionalData.forEach((additionalData) => {
          if (
            ['FIX', 'OTT'].indexOf(additionalData.tip_prikljucka) > -1 &&
            seznamIdPrikljuckov.indexOf(additionalData.id_prikljucek) === -1
          ) {
            seznamPrikljuckov.push(additionalData)
            seznamIdPrikljuckov.push(additionalData.id_prikljucek)
            if (additionalData.id_stranka === this.izbranaStranka) {
              seznamNosilnihPrikljuckov.push(additionalData)
            }
          }
        })
      }
      if (typeof agp['EMAIL'] === 'object') {
        agp['EMAIL'].additionalData.forEach((additionalData) => {
          if (seznamIdPrikljuckov.indexOf(additionalData.id_prikljucek) === -1) {
            seznamPrikljuckov.push(additionalData)
            seznamIdPrikljuckov.push(additionalData.id_prikljucek)
            if (additionalData.id_stranka === this.izbranaStranka) {
              seznamNosilnihPrikljuckov.push(additionalData)
            }
          }
        })
      }
      this.seznamNosilnihPrikljuckov = seznamNosilnihPrikljuckov
      this.seznamPrikljuckov = seznamPrikljuckov
      if (this.seznamNosilnihPrikljuckov.length > 0) {
        this.izbranPrikljucek = this.seznamNosilnihPrikljuckov[0].id_prikljucek
      }
      this.GetSeznamNarocnin()
    },
    MetodaOsveziKreiranElektronskiPredal () {
      this.activetab = 't1'
      this.osvezitevStevec++
    },
    HandleTabClick (tab) {
      this.activetab = tab.name
    },
    SetSeznamNarocnin (seznamNarocnin) {
      this.seznamNarocnin = seznamNarocnin.permission.additionalData
      if (this.seznamNarocnin !== null) {
        for (let i = 0; i < this.seznamNarocnin.length; i++) {
          if (this.izbranaStranka === this.seznamNarocnin[i].id_stranka_sap) {
            this.poslovnaStranka = this.seznamNarocnin[i].poslovna_stranka
          }
        }
      }
    },
    GetSeznamPrikljuckov () {
      let param = ['permissionId=PRIKLJUCKI']
      param.push('filter[tip_prikljucka]=FIX')
      param.push('filter[tip_prikljucka][]=OTT')
      this.clientAgent.postWsRequest(
        this,
        'permissions/havePermission',
        param,
        null,
        'SetSeznamPrikljuckov',
        '')
    },
    SetSeznamPrikljuckov (data) {
      this.seznamPrikljuckov = []
      if (data.permission.results.length > 0) {
        this.seznamPrikljuckov = data.permission.results
      }
    }
  },
  watch: {
    izbranPrikljucek () {
      this.moznoDodajanje = false
      this.seznamNosilnihPrikljuckov.forEach((prikljucek) => {
        if (prikljucek.id_prikljucek === this.izbranPrikljucek && prikljucek.email === undefined) {
          this.moznoDodajanje = true
        }
      })
    }
  }
}
</script>
<style scoped src="./../../../../../static/css/Nastavitve/Email/NastavitveElektronskaPosta.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/NastavitveElektronskaPosta.vue